import React from "react";
import { useTheme } from "styled-components";

const NewStarters = () => {
  const theme = useTheme();
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.063 7.875a.563.563 0 0 1-.563.563h-2.812a.562.562 0 1 1 0-1.126H13.5a.56.56 0 0 1 .563.563M13.5 9.563h-2.812a.562.562 0 1 0 0 1.124H13.5a.562.562 0 1 0 0-1.124m2.813-5.626v10.126a1.125 1.125 0 0 1-1.125 1.124H2.813a1.125 1.125 0 0 1-1.126-1.124V3.938a1.125 1.125 0 0 1 1.126-1.126h12.375a1.125 1.125 0 0 1 1.124 1.126m-1.125 10.126V3.938H2.813v10.125zm-5.644-2.391a.563.563 0 1 1-1.09.281c-.185-.721-.918-1.265-1.705-1.265-.786 0-1.52.544-1.705 1.265a.563.563 0 0 1-1.09-.281 2.8 2.8 0 0 1 1.209-1.641 2.25 2.25 0 1 1 3.173 0 2.8 2.8 0 0 1 1.209 1.64M6.75 9.562a1.125 1.125 0 1 0 0-2.25 1.125 1.125 0 0 0 0 2.25"
        fill={theme.text.text}
      />
    </svg>
  );
};

export default NewStarters;
